export const TECH_CATEGORIES = [
  { name: "Networking", text: "Enterprise switching, routing, wireless controllers and structured cabling systems." },
  { name: "Security & Surveillance", text: "IP cameras, NVR/VMS platforms, analytics and integrated security." },
  { name: "IT Infrastructure", text: "Servers, storage, virtualization and endpoint platforms." },
  { name: "Communication", text: "IP-PBX, EPABX, intercom and business telephony systems." },
  { name: "Power & Continuity", text: "Online and line-interactive UPS, surge protection and battery systems." },
  { name: "Automation", text: "Building and office automation controllers, sensors and control interfaces." },
  { name: "Infrastructure", text: "Racks, enclosures, cabling accessories and physical-layer systems." },
];

export const BRAND_RELATIONSHIPS = [
  { label: "Authorized Partner", text: "Formally authorized to supply and support the manufacturer's products.", tone: "gold" },
  { label: "Technology Partner", text: "A working partnership with certified engineers and direct support channels.", tone: "mid" },
  { label: "Technology Ecosystem", text: "Technologies we design, deploy and support regularly within our solutions.", tone: "dim" },
];

export const SELECTION_CRITERIA = ["Performance", "Reliability", "Compatibility", "Scalability", "Security", "Support", "Lifecycle", "Total Cost of Ownership"];
